export const orderedViewReversed = (language, components) => {
  const langList = ["vn", "ch", "chtr", "chhk", "ko", "jp", "hu", "mn"];
  const isReversed = langList.indexOf(language) !== -1;
  return isReversed ? components.reverse() : components;
};
